import PropTypes from "prop-types";

import HelpIcon from "@mui/icons-material/Help";
import { Paper, Stack, Tooltip, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";

import { formatDate, formatDateTime } from "../../../shared";
import {
  salesRequestStatusColors,
  salesRequestStatusLabels,
} from "@/features/sales-requests";

export const TransactionInformationSection = ({ salesRequest }) => {
  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12 }}>
          <Typography variant="subtitle1">Informasi Transaksi</Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <Typography variant="caption">Nomor PO</Typography>
          <Typography>{salesRequest.purchaseOrder.referenceNumber}</Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <Typography variant="caption">Tanggal Transaksi</Typography>
          <Typography>
            {formatDate(salesRequest.purchaseOrder.transactionDate)}
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <Typography variant="caption">Dibuat pada</Typography>
          <Typography>{formatDateTime(salesRequest.createdAt)}</Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <Typography variant="caption">Dibuat oleh</Typography>
          <Typography>{salesRequest.creator?.name ?? "-"}</Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <Typography variant="caption">Pelanggan</Typography>
          <Typography>{salesRequest.purchaseOrder.buyer.name}</Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <Typography variant="caption">Cabang</Typography>
          <Typography>{salesRequest.purchaseOrder.seller.name}</Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
          <Typography variant="caption">Status</Typography>
          <Stack direction="row" spacing={1} sx={{
            alignItems: "center"
          }}>
            <Typography color={salesRequestStatusColors[salesRequest.status]}>
              {salesRequestStatusLabels[salesRequest.status]}
            </Typography>
            {salesRequest.salesRequestVoidance && (
              <Tooltip
                title={
                  salesRequest.salesRequestVoidance.reason +
                  " (oleh " +
                  salesRequest.salesRequestVoidance.user.name +
                  ")"
                }
              >
                <HelpIcon sx={{ fontSize: "medium", color: "grey" }} />
              </Tooltip>
            )}
          </Stack>
        </Grid>
      </Grid>
    </Paper>
  );
};

TransactionInformationSection.propTypes = {
  salesRequest: PropTypes.object.isRequired,
};
